import { NavigationRailItem } from './NavigationRailItem';

import styles from './NavigationRail.module.scss';
import {useActionChecker, useNavigationItems} from '../../../hooks';
import { useAppSelector } from '../../../../store';

interface IComponentProperties {    
    scollbarVisible:boolean
}
export function NavigationRail (props: IComponentProperties){

    const scollbarVisibleStyle = props.scollbarVisible ? styles['with-scroll']: ''; 

    const actionChecker = useActionChecker();
    const configuration = useAppSelector(state=>state.configuration);
    const authorization = useAppSelector(state=>state.authorization);

    const navigationItems = useNavigationItems(actionChecker, configuration, authorization);

    const NavigationRailItems = navigationItems.map(item => {
        return  <NavigationRailItem key={item.id} labelText={item.labelText} iconName={item.iconName} 
            linkUrl={item.linkUrl} isActive={item.id === navigationItems[0].id}></NavigationRailItem>
    });

    return (
        <nav aria-label="Primary" className={`${styles['NavigationRail']} ${scollbarVisibleStyle}`}>
            <div className={styles["NavigationRail-background"]}></div>
            <div className={styles["NavigationRail-content"]}>
                <ul>
                    {NavigationRailItems}
                </ul>
            </div>
        </nav>
    );

}